import { useRouter } from 'next/router';

export function useRouterNav() {
  const router = useRouter();

  const handleNavigation = (path: string, forceReload: boolean = false) => {
    if (forceReload) {
      router.reload();
    }

    if (path) {
      // router.push(path);
      // temporary change while moving away from page router to app router
      window.location.href = `/make-a-reservation${path.startsWith('/') ? path : `/${path}`}`;
    }
  };

  const handleOffRouteChange = (callback: () => void) =>
    router.events.off('routeChangeComplete', () => callback());
  const handleOnRouteChange = (callback: () => void) =>
    router.events.on('routeChangeComplete', () => callback());

  return {
    handleNavigation,
    handleOffRouteChange,
    handleOnRouteChange
  };
}
